<app-file-field [isEditable]="true" [fileDropArea]="true" [showUploadedList]="false" [multiple]="false"
    [(ngModel)]="requestDocumentObj.document" [documentTypeGroup]="documentGroup" [name]="'document'"
    [dotFloating]="true" [errors]="errorObj.document">
</app-file-field>

<ng-container *ngIf="requestDocumentObj.document">
    <div class="upload">
        <span> <b>{{requestDocumentObj.document?.original_filename}}.{{requestDocumentObj.document?.extension}}</b> |
            {{requestDocumentObj.document?.created_at | date:"dd MMM, yyyy"}} |
            {{embassyService.readableFileSize(requestDocumentObj.document?.size)}}</span>
    </div>
</ng-container>

<button *ngIf="requestDocumentObj.document!=null" mat-raised-button class="Save"
    (click)="postRequestDocuments()">Save</button>

<!-- <div *ngIf="documentList?.results?.length">
    <li *ngFor="let doc of documentList?.results">
        {{doc?.document.original_filename}}
        <span fxLayout="column">
            <small>{{embassyService.readableFileSize(doc.document?.size)}}</small>
            <small>{{doc?.document.created_by.first_name}} {{doc?.document.created_by.last_name}}</small>
            <small>{{doc?.document.created_at | date:"dd MMM, yyyy"}}</small>
        </span>
    </li>
</div> -->

<div class="table-responsive" *ngIf="documentList?.results?.length">
    <mat-table [dataSource]="documentList?.results" class="">
        <ng-container matColumnDef="original_filename">
            <mat-header-cell *matHeaderCellDef> Document Name </mat-header-cell>
            <mat-cell *matCellDef="let doc">
                <a [href]='doc?.document?.document_file' target="_blank"
                    [download]="doc?.document?.original_filename+'.'+doc?.document?.extension">
                    {{doc?.document?.original_filename}}.{{doc?.document?.extension}}</a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="document_size">
            <mat-header-cell *matHeaderCellDef> Size </mat-header-cell>
            <mat-cell *matCellDef="let doc">{{embassyService.readableFileSize(doc?.document?.size)}}</mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="document_type">
            <mat-header-cell *matHeaderCellDef> Document Type </mat-header-cell>
            <mat-cell *matCellDef="let doc">{{doc?.document?.document_type?.name}} </mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="created_by">
            <mat-header-cell *matHeaderCellDef> Uploaded By </mat-header-cell>
            <mat-cell *matCellDef="let doc">
                <div class="details" fxLayout="column">
                    <span class="fw-medium">
                        {{doc?.document?.created_by?.first_name}} {{doc?.document?.created_by?.last_name}}
                    </span>
                    <small>
                        {{doc?.document?.created_at | date:'dd MMM, yyyy'}}
                    </small>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
            <mat-cell *matCellDef="let doc">
                {{ doc?.document?.document_type?.name}}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
            <mat-cell *matCellDef="let doc; let idx = index;">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item>
                        <a [href]='doc?.document?.document_file' target="_blank"
                            [download]="doc?.document?.original_filename+'.'+doc?.document?.extension">
                            <span>Download File</span>
                        </a>
                    </button>
                    <!-- <button mat-menu-item (click)="removeFile(doc?.document,idx)">
            <span>Delete File</span>
          </button> -->
                </mat-menu>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
</div>